import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./language/english.json";
import translationSW from "./language/swahili.json";

const resources = {
  en: {
    translation: translationEN,
  },
  sw: {
    translation: translationSW,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
